import { useState, useEffect } from 'react';
import axios from 'axios';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import CardActions from '@mui/material/CardActions';
import Typography from '@mui/material/Typography';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
// import { useTheme } from '@mui/material/styles';
import HeroButtons from './HeroButtons';
import getTheme from '../theme/theme';
import { ThemeProvider } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { BASEURL } from "../constants/Common"

interface SubscriptionProps {
  title: string;
  price: number;
  currency: string;
  users: number;
  projects: number;
  features: { name: string }[];
}

const SubscriptionPlans = (): JSX.Element => {
  const theme = getTheme();
  const navigate = useNavigate();

  const [subscription, setSubscription] = useState<SubscriptionProps[]>([]);

  const fetchSubscription = () => {
    const url = BASEURL + '/pricing/';
    axios
      .get<SubscriptionProps[]>(url, {
        headers: {
          Accept: 'application/json',
        },
      })
      .then((response) => {
        setSubscription(response.data);
      })
      .catch((error) => console.log(error));
  };

  useEffect(() => {
    fetchSubscription();
  }, []);

  const handleRegister = () => {
    navigate('/register');
  };

  return (
    <ThemeProvider theme={getTheme()}>
      <div id='subscription'>
        <Box
          sx={{
            pt: 5,
            pb: 10,
            px: 2,
            backgroundColor: theme.palette.background.paper,
          }}
        >
          <Box marginBottom={4}>
            <Typography
              variant='h5'
              align='center'
              fontWeight={700}
              marginTop={theme.spacing(1)}
              gutterBottom
              sx={{
                color: theme.palette.text.primary,
                textTransform: 'uppercase',
              }}
            >
              Subscription Plans
            </Typography>
            <Typography
              variant='subtitle1'
              align='center'
              marginTop={theme.spacing(1)}
              gutterBottom
              color={theme.palette.text.primary}
            >
              We offer a range of subscription plans to suit everyone
            </Typography>
          </Box>
          <Container>
            <Grid container spacing={4}>
              {subscription
                .filter((item) => item.title !== 'Premium Plus - Free trial')
                .map((item, i) => (
                  <Grid item xs={12} md={4} key={i}>
                    <Box
                      component={Card}
                      height={1}
                      display='flex'
                      flexDirection='column'
                      boxShadow={0}
                      sx={{

                        backgroundColor: theme.palette.background.default,
                      }}
                      border={`1px solid ${theme.palette.divider}`}

                    >
                      <CardContent
                        sx={{
                          padding: { sm: 4 },
                        }}
                      >
                        <Box
                          marginBottom={4}
                          display='flex'
                          flexDirection='column'
                          alignItems='center'

                        >
                          <Typography variant='h6' sx={{
                            color: theme.palette.text.primary,

                          }} gutterBottom>
                            <Box component='span' fontWeight={600}>
                              {item.title}
                            </Box>
                          </Typography>
                          <Box display='flex' alignItems='flex-start'>
                            <Typography variant='h4' color='#9FCF3A'>
                              <Box
                                component='span'
                                fontWeight={600}
                                marginRight={1 / 2}
                              >
                                {item.currency}
                              </Box>
                            </Typography>
                            <Typography variant='h2' color='#9FCF3A' gutterBottom>
                              <Box component='span' fontWeight={600}>
                                {item.price}

                              </Box>
                              <Typography variant="h6" component="span" sx={{ marginLeft: 0.5 }}>
                                /year
                              </Typography>
                            </Typography>
                          </Box>
                          <Box>
                            <Typography
                              // variant='subtitle2'
                              color={theme.palette.text.primary}
                            >
                              Number of users: {item.users}<br />
                              Number or projects: {item.projects}
                            </Typography>
                          </Box>
                        </Box>
                        <Grid container spacing={1}>
                          {item.features?.map((feature, j) => (
                            <Grid item xs={12} key={j}>
                              <Typography
                                component='p'
                                align='center'
                                sx={{
                                  textDecoration: 'none',
                                }}
                              >
                                {feature.name}
                              </Typography>
                            </Grid>
                          ))}
                        </Grid>
                      </CardContent>
                      <Box flexGrow={1} />
                      <CardActions sx={{ justifyContent: 'center', padding: 4, flexDirection: 'column', alignItems: 'center' }}>
                        {item.title === 'Premium Plus' && (
                          <Button
                            size='large'
                            variant='contained'
                            endIcon={<ArrowForwardIcon />}
                            onClick={handleRegister}
                            sx={{
                              textTransform: 'uppercase',
                              color: theme.palette.common.black,
                              mb: 2,
                            }}
                          >
                            Free trial
                          </Button>
                        )}
                        <Button
                          size='large'
                          variant='contained'
                          endIcon={<ArrowForwardIcon />}
                          onClick={() => handleRegister()}
                          sx={{
                            textTransform: 'uppercase',
                            color: theme.palette.common.black,
                            // color: '9FCF3A',
                            // border: `2px solid ${theme.palette.primary.main}`,
                            // '&:hover': {
                            //   // backgroundColor: '#9FCF3A',
                            //   // color: theme.palette.common.black,
                            //   color: theme.palette.text.primary,
                            //   border: `2px solid ${theme.palette.secondary.main}`,
                            // },
                          }}
                        >
                          Purchase
                        </Button>
                      </CardActions>

                    </Box>
                  </Grid>
                ))}
            </Grid>
          </Container>
        </Box>
      </div>
    </ThemeProvider>
  );
};

export default SubscriptionPlans;
